const entities: Record<string, string> = { "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;" };
export const escapeHtml = (value: string) => value.replace(/[&<>"']/g, character => entities[character]!);
